<template>
  <v-container class="content-wrapper" fluid>
    <v-row v-if="!loading && institutions.length == 0">
      <v-col cols="12">
        <v-btn
          v-show="isMarketplaceHosting"
          depressed
          rounded
          small
          color="blue"
          class="white--text font-weight-bold"
          @click="goBack"
        >
          <v-icon color="black" small class="mr-2">
            mdi-arrow-left
          </v-icon>
          Back
        </v-btn>
      </v-col>
      <v-col cols="12">
        <p>
          No Hosting Institutions found.
        </p>
      </v-col>
    </v-row>
    <v-row v-else class="mb-10 justify-start">
      <v-col
        cols="12"
        xl="4"
        lg="4"
        md="6"
        sm="6"
        xs="12"
        class="pa-3"
        v-for="institution in institutions"
        :key="'institution-' + institution.id"
      >
        <v-hover v-slot="{ hover }">
          <v-card
            class="justify-center align-center"
            elevation="3"
            style="border-radius: 24px; height: 100%; "
            :class="{ 'on-hover': hover }"
            @click="overviewHostingInstitution(institution)"
          >
            <v-card-text>
              <v-row class="text-center">
                <v-col cols="12">
                  <v-avatar size="150px" class="rounded-xl">
                    <v-img contain :src="institution.logoUrl">
                      <template v-slot:placeholder>
                        <v-img lazy-src="@/assets/img/blur.jpg"></v-img>
                      </template>
                    </v-img>
                  </v-avatar>
                </v-col>
                <v-col cols="12" class="mt-12 primary300--text">
                  <b>{{ institution.name }}</b>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>

    <!-- Pagination -->
    <!-- <v-row v-if="pagesLength > 1">
      <v-spacer></v-spacer>
      <v-col cols="4" md="2" class="justify-end d-flex flex-row align-center">
        <div>{{ totalItems }} Results</div>
      </v-col>
      <v-col cols="8" md="2" class="justify-end d-flex flex-row align-center">
        <div class="pr-2">Show:</div>
        <div style="max-width: 90px">
          <v-select
            v-model="options.itemsPerPage"
            :items="[10, 20, 30, 40, 50, { text: 'All', value: -1 }]"
            dense
            outlined
            hide-details
            @change="onItemsPerPageChange"
          ></v-select>
        </div>
      </v-col>
      <v-col cols="12" md="6" class="justify-end d-flex flex-row align-center">
        <v-pagination
          v-model="options.page"
          :length="pagesLength"
          :total-visible="7"
          @input="getFilteredDataFromApi"
        ></v-pagination>
      </v-col>
    </v-row> -->
  </v-container>
</template>

<script>
import EventBus from '@/helpers/event-bus.js';

export default {
  name: 'MarketplaceHostingInstitutionsFiltered',
  data() {
    return {
      // options: {
      //   page: 1,
      //   itemsPerPage: 10,
      //   sortBy: [],
      //   sortDesc: [],
      // },
      institutions: [],
      // totalItems: 0,
      // pagesLength: null,
      loading: false,
      institution: {
        name: '',
      },
    };
  },
  props: {
    filteredParams: {
      type: Object,
    },
    searchMarketplace: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.getFilteredDataFromApi;
  },
  watch: {
    filteredParams: {
      deep: true,
      immediate: true,
      handler(newVal) {
        console.log('filteredParams changed:', newVal);
        this.getFilteredDataFromApi();
      },
    },
  },
  computed: {
    isMarketplaceHosting() {
      return (
        this.$route.path === '/marketplace/hosting-institutions' ||
        this.$route.path === '/public-catalogue-marketplace/hosting-institutions'
      );
    },
  },
  methods: {
    getFilteredDataFromApi() {
      // const paginationParams = this.getParams();
      const filteredParams = {
        // ...paginationParams,
        ...this.filteredParams,
        index: 0,
        size: 1000,
      };

      this.deleteEmptyProperties(filteredParams);

      console.log('Combined params for request:', filteredParams);

      this.loading = true;
      EventBus.$emit('waiting', true);
      this.axios
        .get('/api/v1/hosting-institutions', { params: filteredParams })
        .then(response => {
          console.log('Get Filtered Data:', response.data);
          this.institutions = response.data.content;
          // this.totalItems = response.data.total;
          // this.pagesLength = response.data.pagesLength;
        })
        .catch(error => {
          console.error('Error fetching hosting institution:', error);
        })
        .finally(() => {
          this.loading = false;
          EventBus.$emit('waiting', false);
        });
    },
    deleteEmptyProperties(obj) {
      if (!obj || typeof obj !== 'object') {
        return;
      }

      if (Array.isArray(obj)) {
        obj.forEach((item, index) => {
          if (item === null || item === undefined || item === '') {
            obj.splice(index, 1);
          } else if (typeof item === 'object') {
            this.deleteEmptyProperties(item);
            if (Object.keys(item).length === 0) {
              obj.splice(index, 1);
            }
          }
        });
      } else {
        for (const key in obj) {
          if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
            delete obj[key];
          } else if (Array.isArray(obj[key])) {
            this.deleteEmptyProperties(obj[key]);
            if (obj[key].length === 0) {
              delete obj[key];
            }
          } else if (typeof obj[key] === 'object') {
            this.deleteEmptyProperties(obj[key]);
            if (Object.keys(obj[key]).length === 0) {
              delete obj[key];
            }
          }
        }
      }
    },
    // onItemsPerPageChange() {
    //   this.options.page = 1;
    //   this.getFilteredDataFromApi();
    // },
    // getParams() {
    //   const { page, itemsPerPage } = this.options;
    //   const query = {
    //     index: itemsPerPage === -1 ? 0 : page - 1,
    //     size: itemsPerPage === -1 ? 1000 : itemsPerPage,
    //   };
    //   return query;
    // },
    overviewHostingInstitution(institution) {
      if (this.$store.getters.roles != null) {
        const marketplaceInstitutionViewAll = true;
        const institutionSearchMarketplace = true;

        if (this.searchMarketplace) {
          this.$router.push({
            name: 'OverviewHostingInstitution',
            params: { id: institution.id },
            query: {
              institutionSearchMarketplace,
              filters: true,
              text: this.$route.query.text,
            },
          });
        } else {
          this.$router.push({
            name: 'OverviewHostingInstitution',
            params: { id: institution.id },
            query: {
              marketplaceInstitutionViewAll,
              filters: true,
              ...this.filteredParams,
            },
          });
        }
      } else {
        const marketplaceInstitutionViewAll = true;
        const institutionSearchMarketplace = true;

        if (this.searchMarketplace) {
          this.$router.push({
            name: 'PublicOverviewHostingInstitution',
            params: { id: institution.id },
            query: {
              institutionSearchMarketplace,
              filters: true,
              text: this.$route.query.text,
            },
          });
        } else {
          this.$router.push({
            name: 'PublicOverviewHostingInstitution',
            params: { id: institution.id },
            query: {
              marketplaceInstitutionViewAll,
              filters: true,
              ...this.filteredParams,
            },
          });
        }
      }
    },
    goBack() {
      this.$emit('changeTab');
    },
  },
};
</script>
